module.exports = __webpack_public_path__ + "assets/resstar1-0at2x.0c1fe8c7ff661183e3c961882c0010b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/stars/resstar1-0at2x.png
// module id = 852
// module chunks = 0